import { z } from "zod"

export const updateContactResendEmailSchema = z.object({
  funnel_contact: z.object({
    email: z.string().nonempty('Campo obrigatório')
  }),
})

export type LeadsFunnelUpdateContactResendEmailValidationSchema = z.infer<typeof updateContactResendEmailSchema>